import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import PureRenderMixin from './external-adapters/pureRenderMixinAdapter.js';
import ComponentVisibilityMixin from '../../external/react/addons/ComponentVisibilityMixin.js';
import { ViewTrackingContext } from './ViewTrackingContext.js';

export const TrackSectionView = createReactClass({
    propTypes: {
        sectionName: PropTypes.string.isRequired,
        children: PropTypes.any.isRequired,
    },

    mixins: [
        PureRenderMixin,
        ComponentVisibilityMixin,
    ],

    componentVisibilityChanged: function () {
        const trackView = this.context;
        trackView(this.props.sectionName);
        this.disableVisibilityHandling();
    },

    render: function () {
        return this.props.children;
    },
});
TrackSectionView.contextType = ViewTrackingContext;
